/*
  Scroll animation logic for the hero section. Moved out of the Custom
  Liquid block because that block is capped at 50,000 characters. Loaded
  with defer from heroCarouselAnimation.liquid.
*/
document.addEventListener('DOMContentLoaded', function () {

  // The three title/image boxes below each sit inside their own
  // separate translucent background, not as flex siblings of each
  // other, so CSS alone can't stretch them to match one another the
  // way the backgrounds do. A longer product title that wraps to an
  // extra line would otherwise leave just that one box taller, and on
  // mobile (where cards stack instead of sitting in a row) that shows
  // up as a different gap above the button on every card. Run before
  // the mobile/desktop fork below since it applies to both.
  var productCardBoxElements = document.querySelectorAll('.hero-spline-product-card');

  function syncProductCardHeights() {
    var tallestCardHeight = 0;

    for (var cardIndex = 0; cardIndex < productCardBoxElements.length; cardIndex++) {
      productCardBoxElements[cardIndex].style.height = '';
    }

    for (var cardIndex = 0; cardIndex < productCardBoxElements.length; cardIndex++) {
      var cardHeight = productCardBoxElements[cardIndex].offsetHeight;
      if (cardHeight > tallestCardHeight) {
        tallestCardHeight = cardHeight;
      }
    }

    for (var cardIndex = 0; cardIndex < productCardBoxElements.length; cardIndex++) {
      productCardBoxElements[cardIndex].style.height = tallestCardHeight + 'px';
    }
  }

  syncProductCardHeights();

  // Decided once at load, not tracked live, so a mobile visitor never
  // downloads Spline's viewer script and scene, and a tablet+ visitor
  // never downloads the mobile video. Checked here instead of a CSS
  // media query since CSS alone can't stop an asset from downloading.
  var isMobileViewport = window.matchMedia('(max-width: 768px)').matches;

  if (isMobileViewport) {
    var mobileVideoElement = document.getElementById('heroMobileVideo');
    mobileVideoElement.src = 'https://cdn.shopify.com/videos/c/o/v/a04757d0c2994e098f29609c5be95f6b.mp4';
    // Some mobile browsers don't reliably pick up a script-set src on
    // their own, load() forces it to actually start fetching instead
    // of intermittently sitting blank until the next page load.
    mobileVideoElement.load();
    mobileVideoElement.play().catch(function () {
      // Autoplay can still be blocked in rare cases, nothing to do here.
    });
    return;
  }

  // Loads Spline's own viewer script, this is what draws the 3D scene.
  // Only added here so mobile visitors skip this download entirely.
  var splineScriptElement = document.createElement('script');
  splineScriptElement.type = 'module';
  splineScriptElement.src = 'https://unpkg.com/@splinetool/viewer@1.12.98/build/spline-viewer.js';
  document.head.appendChild(splineScriptElement);

  // Grabs the main elements this script needs to read and control.
  var sectionElement = document.getElementById('heroSplineSection');
  var stickyElement = document.querySelector('.hero-spline-sticky');

  // The theme's sticky header overlaps our section, so we measure it
  // live and pin below it instead, keeping the Spline canvas fully
  // unobstructed. Two elements share this class (an announcement bar
  // and the header), so we use whichever is currently taller.
  var stickyHeaderElements = document.querySelectorAll('.shopify-section-group-header-group');
  var lastKnownHeaderHeight = -1;

  function measureStickyHeaderHeight() {
    var tallestHeaderHeight = 0;

    for (var elementIndex = 0; elementIndex < stickyHeaderElements.length; elementIndex++) {
      var elementHeight = stickyHeaderElements[elementIndex].offsetHeight;
      if (elementHeight > tallestHeaderHeight) {
        tallestHeaderHeight = elementHeight;
      }
    }

    return tallestHeaderHeight;
  }

  // Saves the height and updates the CSS variable, but only when it
  // actually changed, to avoid triggering layout work for nothing.
  function applyStickyHeaderHeight(height) {
    if (height !== lastKnownHeaderHeight) {
      lastKnownHeaderHeight = height;
      sectionElement.style.setProperty('--hero-spline-header-height', height + 'px');
    }
  }

  // Pairs each pulse icon with the heading it sits beside.
  var pulseIconPairs = [
    { icon: document.getElementById('pulseIcon1'), heading: document.querySelector('#heroText1 .hero-spline-heading') },
    { icon: document.getElementById('pulseIcon2'), heading: document.querySelector('#heroText2 .hero-spline-heading') }
  ];

  // Centers each icon on its heading and sits it left of the content,
  // measured live so it stays correct regardless of alignment or wrap.
  var iconToContentGap = 24;

  function syncPulseIconPositions() {
    var stickyRect = stickyElement.getBoundingClientRect();

    for (var pairIndex = 0; pairIndex < pulseIconPairs.length; pairIndex++) {
      var pair = pulseIconPairs[pairIndex];
      var headingRect = pair.heading.getBoundingClientRect();
      var contentRect = pair.heading.parentElement.getBoundingClientRect();

      var iconTop = headingRect.top - stickyRect.top + (headingRect.height / 2) - (pair.icon.offsetHeight / 2);
      var iconLeft = contentRect.left - stickyRect.left - iconToContentGap - pair.icon.offsetWidth;

      pair.icon.style.top = iconTop + 'px';
      pair.icon.style.left = iconLeft + 'px';
    }
  }

  // Tablet-only horizontal scroll indicator for the product cards row.
  // Harmless outside that range too, since the row never actually
  // overflows there and the indicator itself stays hidden via CSS.
  var productCardsRowElement = document.getElementById('productCardsRow');
  var productCardsScrollbarElement = document.getElementById('productCardsScrollbar');
  var productCardsScrollbarThumbElement = document.getElementById('productCardsScrollbarThumb');
  var productCardsScrollArrowElements = document.querySelectorAll('.hero-spline-product-scroll-arrow');

  // Sizes and positions the thumb to match how much of the row is
  // visible and how far it has been scrolled, same idea as a native
  // scrollbar thumb. Hides the whole indicator if there is nothing to
  // scroll (e.g. only 2 cards fit on-screen but all 3 already do),
  // rather than showing a full-width bar that implies scrolling works.
  function syncProductCardsScrollbarThumb() {
    var trackWidth = productCardsRowElement.clientWidth;
    var contentWidth = productCardsRowElement.scrollWidth;

    if (contentWidth <= trackWidth) {
      productCardsScrollbarElement.style.display = 'none';
      return;
    }

    // Clears the inline override above, so the tablet media query's
    // display:flex takes over again once there is something to scroll.
    productCardsScrollbarElement.style.display = '';

    var visibleFraction = trackWidth / contentWidth;
    var scrollableDistance = contentWidth - trackWidth;
    var scrolledFraction = productCardsRowElement.scrollLeft / scrollableDistance;

    productCardsScrollbarThumbElement.style.width = (visibleFraction * 100) + '%';
    productCardsScrollbarThumbElement.style.left = (scrolledFraction * (1 - visibleFraction) * 100) + '%';
  }

  productCardsRowElement.addEventListener('scroll', syncProductCardsScrollbarThumb);

  // Each arrow scrolls by one card width (card width plus its gap).
  for (var arrowIndex = 0; arrowIndex < productCardsScrollArrowElements.length; arrowIndex++) {
    productCardsScrollArrowElements[arrowIndex].addEventListener('click', function (event) {
      var direction = Number(event.currentTarget.getAttribute('data-scroll-direction'));
      productCardsRowElement.scrollBy({ left: direction * 327, behavior: 'smooth' });
    });
  }

  // Each keyframe is a scroll progress plus opacity/x/y/scale at that
  // point. Two matching keyframes in a row means it holds still there.
  var animatedItems = [

    // Hero Text #1: visible during scroll-in, gone right as it locks.
    {
      element: document.getElementById('heroText1'),
      keyframes: [
        { at: -0.106, opacity: 1, x: 0, y: 0, scale: 1 },
        { at: -0.082, opacity: 0, x: 150, y: 0, scale: 1 }
      ]
    },

    // Hero Text #2: enters right as pulse icon #2 arrives, holds, then
    // exits before the icon does (same relay order as pair #1).
    {
      element: document.getElementById('heroText2'),
      keyframes: [
        { at: -0.118, opacity: 0, x: 150, y: 0, scale: 1 },
        { at: 0.053, opacity: 0, x: 150, y: 0, scale: 1 },
        { at: 0.105, opacity: 1, x: 0, y: 0, scale: 1 },
        { at: 0.535, opacity: 1, x: 0, y: 0, scale: 1 },
        { at: 0.620, opacity: 0, x: 150, y: 0, scale: 1 },
        { at: 1.088, opacity: 0, x: 150, y: 0, scale: 1 }
      ]
    },

    // Pulse icon #1: follows Hero Text #1 out, fully gone by the lock.
    {
      element: document.getElementById('pulseIcon1'),
      keyframes: [
        { at: -0.106, opacity: 1, x: 0, y: 0, scale: 1 },
        { at: -0.053, opacity: 1, x: 0, y: 0, scale: 1 },
        { at: 0.000, opacity: 0, x: -150, y: 0, scale: 1 },
        { at: 1.088, opacity: 0, x: -150, y: 0, scale: 1 }
      ]
    },

    // Pulse icon #2: arrives right as pulse icon #1 finishes vanishing,
    // no dead gap between the pairs.
    {
      element: document.getElementById('pulseIcon2'),
      keyframes: [
        { at: -0.118, opacity: 0, x: -150, y: 0, scale: 1 },
        { at: 0.000, opacity: 0, x: -150, y: 0, scale: 1 },
        { at: 0.053, opacity: 1, x: 0, y: 0, scale: 1 },
        { at: 0.591, opacity: 1, x: 0, y: 0, scale: 1 },
        { at: 0.699, opacity: 0, x: -150, y: 0, scale: 1 },
        { at: 1.088, opacity: 0, x: -150, y: 0, scale: 1 }
      ]
    },

    // Product cards pop up one after another near the end.
    {
      element: document.getElementById('productCard1'),
      keyframes: [
        { at: 0.000, opacity: 0, x: 0, y: 20, scale: 0.8 },
        { at: 0.926, opacity: 0, x: 0, y: 20, scale: 0.8 },
        { at: 0.979, opacity: 1, x: 0, y: 0, scale: 1 },
        { at: 1.088, opacity: 1, x: 0, y: 0, scale: 1 }
      ]
    },
    {
      element: document.getElementById('productCard2'),
      keyframes: [
        { at: 0.000, opacity: 0, x: 0, y: 20, scale: 0.8 },
        { at: 0.979, opacity: 0, x: 0, y: 20, scale: 0.8 },
        { at: 1.035, opacity: 1, x: 0, y: 0, scale: 1 },
        { at: 1.088, opacity: 1, x: 0, y: 0, scale: 1 }
      ]
    },
    {
      element: document.getElementById('productCard3'),
      keyframes: [
        { at: 0.000, opacity: 0, x: 0, y: 20, scale: 0.8 },
        { at: 1.035, opacity: 0, x: 0, y: 20, scale: 0.8 },
        { at: 1.088, opacity: 1, x: 0, y: 0, scale: 1 }
      ]
    },

    // Tablet scroll indicator arrives with the last card, since there is
    // nothing to scroll between until the whole row is on screen. Fades
    // only, no pop, so it does not compete with the cards behind it.
    {
      element: document.getElementById('productCardsScrollbar'),
      keyframes: [
        { at: 0.000, opacity: 0, x: 0, y: 0, scale: 1 },
        { at: 1.035, opacity: 0, x: 0, y: 0, scale: 1 },
        { at: 1.088, opacity: 1, x: 0, y: 0, scale: 1 }
      ]
    }

  ];

  // Blends between the two keyframes on either side of scrollProgress.
  function getInterpolatedFrame(scrollProgress, keyframes) {
    var lastIndex = keyframes.length - 1;

    var clampedProgress = scrollProgress;
    if (clampedProgress < keyframes[0].at) {
      clampedProgress = keyframes[0].at;
    }
    if (clampedProgress > keyframes[lastIndex].at) {
      clampedProgress = keyframes[lastIndex].at;
    }

    var previousFrame = keyframes[0];
    var nextFrame = keyframes[lastIndex];

    for (var frameIndex = 0; frameIndex < lastIndex; frameIndex++) {
      if (clampedProgress >= keyframes[frameIndex].at && clampedProgress <= keyframes[frameIndex + 1].at) {
        previousFrame = keyframes[frameIndex];
        nextFrame = keyframes[frameIndex + 1];
        break;
      }
    }

    var frameRange = nextFrame.at - previousFrame.at;
    var frameProgress = 0;
    if (frameRange > 0) {
      frameProgress = (clampedProgress - previousFrame.at) / frameRange;
    }

    return {
      opacity: previousFrame.opacity + (nextFrame.opacity - previousFrame.opacity) * frameProgress,
      x: previousFrame.x + (nextFrame.x - previousFrame.x) * frameProgress,
      y: previousFrame.y + (nextFrame.y - previousFrame.y) * frameProgress,
      scale: previousFrame.scale + (nextFrame.scale - previousFrame.scale) * frameProgress
    };
  }

  // Applies one blended frame's opacity, position, and size to an element.
  // Buttons/links inside these elements force pointer-events:auto in CSS,
  // so opacity alone does not stop clicks once something is fully faded
  // out. Visibility does block clicks even against that override, so it
  // is toggled off only at exactly 0 opacity (the held, fully-hidden
  // state), not during the fade itself.
  function applyFrameToElement(element, frame) {
    element.style.opacity = frame.opacity;
    element.style.transform = 'translate(' + frame.x + 'px, ' + frame.y + 'px) scale(' + frame.scale + ')';
    element.style.visibility = frame.opacity <= 0 ? 'hidden' : 'visible';
  }

  // 0 = locked, 1 = unlocked, negative = still scrolling in, based on
  // the fixed 400px distance so it stays the same on any screen.
  // "Locked" means the top is at the sticky header's height, not 0,
  // since that is where the section actually pins.
  function getScrollProgress() {
    if (lastKnownHeaderHeight === -1) {
      applyStickyHeaderHeight(measureStickyHeaderHeight());
    }

    var stickyHeaderHeight = lastKnownHeaderHeight;
    var sectionRect = sectionElement.getBoundingClientRect();
    var effectiveViewportHeight = window.innerHeight - stickyHeaderHeight;
    var lockedScrollDistance = sectionElement.offsetHeight - effectiveViewportHeight;

    if (lockedScrollDistance <= 0) {
      return 0;
    }

    var scrollProgress = -(sectionRect.top - stickyHeaderHeight) / lockedScrollDistance;

    // Only update the header height when clearly outside the animated
    // range, not mid-scroll. The header can grow taller if the
    // announcement bar reappears near the top of the page, and
    // changing our own height while animating would make the section
    // jump instead of moving smoothly.
    if (scrollProgress < -0.5 || scrollProgress > 1.5) {
      applyStickyHeaderHeight(measureStickyHeaderHeight());
    }

    if (scrollProgress > 1.088) {
      scrollProgress = 1.088;
    }

    return scrollProgress;
  }

  // Updates every animated item to match the current scroll progress.
  function applyScrollProgress() {
    var scrollProgress = getScrollProgress();

    for (var itemIndex = 0; itemIndex < animatedItems.length; itemIndex++) {
      var item = animatedItems[itemIndex];
      var frame = getInterpolatedFrame(scrollProgress, item.keyframes);
      applyFrameToElement(item.element, frame);
    }
  }

  // Limits updates to once per animation frame, keeps scroll smooth.
  var updateIsScheduled = false;

  function requestScrollUpdate() {
    if (updateIsScheduled) {
      return;
    }
    updateIsScheduled = true;
    window.requestAnimationFrame(function () {
      applyScrollProgress();
      updateIsScheduled = false;
    });
  }

  // The Spline scene drives itself off raw page scroll (0 to 500px) and
  // sometimes freezes part way through its reverse spin when you scroll
  // back to the top, leaving the container turned around and the lid
  // still off. The scene cannot be asked to finish, so we ease it home
  // ourselves once scrolling stops there.

  // Where every object sits before any scrolling happens, recorded once
  // the scene loads. Stays null if the page did not load at the very
  // top, since then there is no way to tell what "at rest" looks like.
  var splineRestingTransforms = null;

  // How long the scene takes to glide home. Raise it for a slower,
  // gentler return, lower it if the correction feels too floaty.
  var splineReturnDuration = 500;

  // Differences smaller than this count as already in place, which keeps
  // tiny floating point wobble from triggering a pointless correction.
  var splineTransformTolerance = 0.001;

  // The nine numbers read and written per object, as part plus axis.
  var splineParts = ['position', 'rotation', 'scale'];
  var splineAxes = ['x', 'y', 'z'];

  var splineReturnFrame = null;
  var splineSettleTimer = null;
  var splineCaptureAttempts = 0;

  // Reads an object's position, rotation and scale into nine numbers.
  function readSplineTransform(splineObject) {
    var values = [];

    for (var partIndex = 0; partIndex < 3; partIndex++) {
      for (var axisIndex = 0; axisIndex < 3; axisIndex++) {
        values.push(splineObject[splineParts[partIndex]][splineAxes[axisIndex]]);
      }
    }

    return values;
  }

  // Puts nine numbers back onto an object.
  function writeSplineTransform(splineObject, values) {
    for (var partIndex = 0; partIndex < 3; partIndex++) {
      for (var axisIndex = 0; axisIndex < 3; axisIndex++) {
        splineObject[splineParts[partIndex]][splineAxes[axisIndex]] = values[partIndex * 3 + axisIndex];
      }
    }
  }

  // Records the whole scene rather than one object, so the lid and any
  // other moving part are covered without having to name them here.
  // Gives up if the visitor scrolls first, because the scene will have
  // already moved and there would be nothing trustworthy to record.
  function trySplineCapture() {
    var viewer = document.getElementById('heroSplineViewer');

    if (window.scrollY > 2) {
      return;
    }

    if (viewer && viewer._spline && viewer._loaded) {
      var splineObjects = viewer._spline.getAllObjects();
      splineRestingTransforms = [];

      for (var objectIndex = 0; objectIndex < splineObjects.length; objectIndex++) {
        splineRestingTransforms.push({
          splineObject: splineObjects[objectIndex],
          values: readSplineTransform(splineObjects[objectIndex])
        });
      }

      return;
    }

    // Roughly fifteen seconds of waiting for the scene, then stop so a
    // scene that never loads does not leave this checking forever.
    splineCaptureAttempts++;

    if (splineCaptureAttempts < 900) {
      window.requestAnimationFrame(trySplineCapture);
    }
  }

  trySplineCapture();

  // Stops a glide already in progress, so real scrolling always wins.
  function cancelSplineReturn() {
    if (splineReturnFrame !== null) {
      window.cancelAnimationFrame(splineReturnFrame);
      splineReturnFrame = null;
    }
  }

  // Eases every object that drifted back to where it started.
  function startSplineReturn() {
    if (!splineRestingTransforms) {
      return;
    }

    var driftedObjects = [];

    // Works out which objects actually need moving. Usually none, since
    // the scene normally finds its own way back.
    for (var restingIndex = 0; restingIndex < splineRestingTransforms.length; restingIndex++) {
      var resting = splineRestingTransforms[restingIndex];
      var current = readSplineTransform(resting.splineObject);

      for (var valueIndex = 0; valueIndex < 9; valueIndex++) {
        if (Math.abs(current[valueIndex] - resting.values[valueIndex]) > splineTransformTolerance) {
          driftedObjects.push({ splineObject: resting.splineObject, from: current, to: resting.values });
          break;
        }
      }
    }

    if (driftedObjects.length === 0) {
      return;
    }

    var startTime = null;

    function stepSplineReturn(currentTime) {
      if (startTime === null) {
        startTime = currentTime;
      }

      var progress = (currentTime - startTime) / splineReturnDuration;

      if (progress > 1) {
        progress = 1;
      }

      // Slows down as it arrives instead of stopping dead.
      var eased = 1 - Math.pow(1 - progress, 3);

      for (var driftedIndex = 0; driftedIndex < driftedObjects.length; driftedIndex++) {
        var drifted = driftedObjects[driftedIndex];
        var blended = [];

        for (var blendIndex = 0; blendIndex < 9; blendIndex++) {
          blended.push(drifted.from[blendIndex] + (drifted.to[blendIndex] - drifted.from[blendIndex]) * eased);
        }

        writeSplineTransform(drifted.splineObject, blended);
      }

      if (progress < 1) {
        splineReturnFrame = window.requestAnimationFrame(stepSplineReturn);
      } else {
        splineReturnFrame = null;
      }
    }

    cancelSplineReturn();
    splineReturnFrame = window.requestAnimationFrame(stepSplineReturn);
  }

  // Only corrects at the very top of the page, and only once scrolling has
  // actually stopped, so it can never fight the scroll-driven animation.
  function scheduleSplineReturn() {
    cancelSplineReturn();
    window.clearTimeout(splineSettleTimer);

    if (window.scrollY > 2) {
      return;
    }

    splineSettleTimer = window.setTimeout(startSplineReturn, 150);
  }

  // Re-runs everything whenever the page scrolls or the window resizes.
  window.addEventListener('scroll', function () {
    requestScrollUpdate();
    scheduleSplineReturn();
  });
  window.addEventListener('resize', function () {
    // A real viewport dimension change, not a scroll-direction header
    // quirk, so this always applies immediately (unlike the guarded
    // re-check inside getScrollProgress).
    applyStickyHeaderHeight(measureStickyHeaderHeight());
    syncPulseIconPositions();
    syncProductCardsScrollbarThumb();
    requestScrollUpdate();
  });

  // Sets the correct state in case the page loads mid-scroll. Header
  // height first, so the sticky element's measured rect below already
  // reflects the correct pinned position.
  applyStickyHeaderHeight(measureStickyHeaderHeight());
  syncPulseIconPositions();
  syncProductCardsScrollbarThumb();
  applyScrollProgress();

});
